import axios from 'axios';

import { getEnv } from '@/utils';

const { GO_ENDPOINT, SITE_TYPE } = getEnv();

export const getShippingCosts = async (userId) => {
  const { data } = await axios.get(
    `${GO_ENDPOINT}/v1/${SITE_TYPE}/shipping_costs/${userId}`
  );

  return data;
};
